import React from "react";
import "./successDialog.scss";
import { useEffect, useState } from "react";
import UKDialog from "@/components/UKDialog";
import { useTranslation } from "@/i18n/client";
import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton } from "@mui/material";
import SuccessIcon from "@/assets/icons/SuccessIcon.svg";
import OutOfStackController from "./outofStockController";
import JDILogin from "@/app/login/index.login";

interface DialogProps {
  open: boolean;
  email: string;
  isShowBind?: boolean;
  isShowVerify?: boolean;
  isShowLogin?: boolean;
  isShowCancel?: boolean;
  onSuccess?: () => void;
  onFail?: () => void;
  closeFn: () => void;
}

const SubmitBTnStyle = {
  textTransform: "none",
  height: "32px",
  fontSize: "14px",
  lineHeight: "18px",
  color: "#FFFFFF",
  background: "#CC0C1C",
  border: "1px solid #E0E1E5",
  "&.Mui-disabled": {
    backgroundColor: "#FF9FA7",
    color: "#FFFFFF",
  },
}

const CancelBTnStyle = {
  textTransform: "none",
  margin: "0px 10px",
  height: "32px",
  fontSize: "14px",
  color: "#1A1A1A",
  border: "1px solid #E0E1E5",
}

const SignUpSuccessDialog = ({ open, email, isShowBind = false, isShowVerify = false, isShowLogin = false, isShowCancel = false, onSuccess, closeFn }: DialogProps) => {

  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = () => {
    setIsOpen(false);
    closeFn && closeFn();
    onSuccess && onSuccess();
  };

  const onBindEmail = () => {
    handleClose();
    OutOfStackController.getInstance().openVerifyEmailDialog(email, true);
  };

  const onVerifyEmail = () => {
    handleClose();
    OutOfStackController.getInstance().openVerifyEmailDialog(email);
  };

  const onLoginIn = () => {
    handleClose();
    JDILogin.getInstance().openLoginDialog();
  };

  const getDialogStyle = () => {
    if(isShowCancel){
      return {
        width: "466px",
        minHeight: "276px",
        borderRadius: "12px",
      }
    }
    else{
      return {
        width: "386px",
        minHeight: "196px",
        borderRadius: "12px",
      }
    }
  };

  return (
    <UKDialog
      open={isOpen}
      showCloseBtn={false}
      onClose={handleClose}
      sx={{"& .MuiDialog-paper": getDialogStyle()}}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <div className="sign-up">
        <SuccessIcon width={30} height={30} />
        <div className="title">{t("outofstock.signUp")}</div>
        <div className="desc">
          <div>{t("outofstock.signUpDesc")}</div>
          { isShowLogin && <div>{t("outofstock.loginDesc")}</div>}
          { (isShowVerify || isShowBind) && <div>{t("outofstock.verifyDesc")}</div>}
        </div>
        <div className="dialog-footer">
          { isShowCancel && <Button sx={CancelBTnStyle} onClick={handleClose}>{t("login.common.cancel")}</Button>}
          { isShowBind && <Button sx={SubmitBTnStyle} onClick={onBindEmail}>{t("outofstock.bind")}</Button>}
          { isShowVerify && <Button sx={SubmitBTnStyle} onClick={onVerifyEmail}>{t("outofstock.verify")}</Button>}
          { isShowLogin && <Button sx={SubmitBTnStyle} onClick={onLoginIn}>{t("outofstock.toLogin")}</Button>}
        </div>
      </div>
    </UKDialog>
  );

}

export default SignUpSuccessDialog;